import { useInitOrderRequest } from 'components/payment/payment.new.hooks';
import { useSpreedlyScriptLoading } from 'components/payment/spreedly/spreedly-payments.hooks';
import { useURLSearchParams } from 'hooks/useURLSearchParams';

export const useSpreedlyHosted = () => {
  const urlSearchParams = useURLSearchParams();
  const { loading: spreedlyScriptLoading } = useSpreedlyScriptLoading();
  const initOrderBody = {
    attributes: {},
    otherData: null,
    orderId: urlSearchParams.get('orderId'),
    locationId: urlSearchParams.get('locationId'),
    merchantId: urlSearchParams.get('merchantId'),
  };

  const { loading, setLoading, initOrderResponse, refetchInitOrder } =
    useInitOrderRequest(initOrderBody, {
      headers: { CLIENTID: urlSearchParams.get('clientId') },
    });

  return {
    loading,
    setLoading,
    initOrderResponse,
    refetchInitOrder,
    spreedlyScriptLoading,
  };
};
